import "./SideNavBar.css";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { RiDashboard2Fill } from "react-icons/ri";
import { AiFillBank } from "react-icons/ai";
import { RiLandscapeFill } from "react-icons/ri";
import { TbFileLike } from "react-icons/tb";
import {
  GiChemicalDrop,
  GiHotMeal,
  GiPlantRoots,
  GiPlantWatering,
  GiScissors,
  GiSprout,
} from "react-icons/gi";

import {
  MdContactSupport,
  MdDescription,
  MdOutlineCategory,
  MdQuestionAnswer,
  MdSearch,
} from "react-icons/md";
import { FaBox, FaFileAlt, FaSignOutAlt, FaUsers, FaUserTie } from "react-icons/fa";
import { LuGoal } from "react-icons/lu";
import { SiDevpost } from "react-icons/si";
import { GrTransaction } from "react-icons/gr";
import { logoutUser } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { LogoutModal } from "./CustomForm";
import { AiFillSave } from "react-icons/ai";

const linkList = [
  {
    icon: <RiDashboard2Fill className="icon-md" />,
    text: "Dashboard",
    url: "/admin/dashboard",
  },
  {
    icon: <FaUsers className="icon-md" />,
    text: "Appraisers",
    url: "/admin/users",
  },
  {
    icon: <FaUsers className="icon-md" />,
    text: "Lenders",
    url: "/admin/lenders",
  },
  {
    icon: <MdOutlineCategory className="icon-md" />,
    text: "Jobs",
    url: "/admin/jobs",
  },
  {
    icon: <MdDescription className="icon-md" />,
    text: "Content",
    url: "/admin/content",
  },
  {
    icon: <SiDevpost className="icon-md" />,
    text: "Designation",
    url: "/admin/designation",
  },
  {
    icon: <FaUserTie className="icon-md" />,
    text: "Applicant",
    url: "/admin/applicant",
  },
  {
    icon: <RiLandscapeFill className="icon-md"/>,
 text:"Property Preference",
 url:'/admin/property_preference'
  },
  {
    icon: <AiFillSave className="icon-md"/>,
 text:"Intended Use",
 url:'/admin/appraiser_purpose'
  },
  {
    icon: <TbFileLike className="icon-md"/>,
 text:"Intended User's",
 url:'/admin/intended_user'
  },{
    icon: <LuGoal className="icon-md"/>,
 text:"Property Occupied",
 url:'/admin/property_occupied'
  },
  {
    icon: <GrTransaction className="icon-md" />,
    text: "Transactions",
    url: "/admin/transactions",
  },
  {
    icon: <MdContactSupport className="icon-md" />,
    text: "Queries",
    url: "/admin/queries",
  },
  // {
  //   icon: <MdQuestionAnswer className="icon-md" />,
  //   text: "Queries",
  //   url: "/admin/queries",
  // },
];

const active_text = {
  Dashboard: "dashboard",
  Appraisers: "users",
  Lenders: "lenders",
  Jobs: "jobs",
  Content: "content",
};

export default function SideNavbar({ isExpanded }) {
  const pathname = window.location.pathname;
  const [activeLink, setActiveLink] = useState("Dashboard");
  const [showModal, setShowModal] = useState(false);
  const userInfo = useSelector((state) => state.adminSlice.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const signoutHandler = (e) => {
    e.preventDefault();
    logoutUser(dispatch);
    navigate("/");
    setShowModal(false);
  };

  const activeLinkHandler = (text) => {
    return pathname.includes(active_text[text]);
  };

  const cls = `nav-item has-treeview ${isExpanded ? "menu-item" : "menu-item menu-item-NX"
    }`;

  // console.log({ userInfo });
  return (
    <>
      {userInfo ? (
        <div
          className={
            isExpanded
              ? "side-nav-container"
              : "side-nav-container side-nav-container-NX"
          }
        >
          <Link to={"/admin/dashboard"}>
            <div className="brand-link">
              <img src="/Vector.png" alt="" width={"60px"} height="auto" />
              <span className="brand-text ms-2 font-weight-light">
                Appraiser
              </span>
            </div>
          </Link>

          <div className="sidebar">
            {/* Sidebar user panel (optional) */}
            <div className="user-panel mt-3 pb-3 mb-3 d-flex">
              <div className="info">
                <Link to="/admin/view-profile" className="d-block">
                  {userInfo.image && (
                    <img
                      src={userInfo.image}
                      alt=""
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        marginRight: "0.5rem",
                      }}
                    />
                  )}
                  <span className="info-text">
                    Welcome {userInfo ? <b>{userInfo.name}</b> : "Back"}
                  </span>
                </Link>
              </div>
            </div>
            {/* Sidebar Menu */}
            <nav className="mt-2">
              <ul
                className="nav-pills nav-sidebar px-0 d-flex flex-column flex-wrap"
                data-widget="treeview"
                role="menu"
                data-accordion="false"
              >
                {linkList.map(({ icon, text, url }) => (
                  <li
                    key={url}
                    className={`${cls} ${activeLinkHandler(text) && "active-item"
                      }`}
                    onClick={() => setActiveLink(text)}
                  >
                    <Link to={url} className="nav-link">
                      {icon}
                      <p className="ms-2">{text}</p>
                    </Link>
                  </li>
                ))}

                <li className={cls}>
                  <p onClick={() => setShowModal(true)} className="nav-link">
                    <FaSignOutAlt className="icon-md" />
                    <p className="ms-2">Log Out</p>
                  </p>
                </li>
              </ul>
            </nav>
            {/* /.sidebar-menu */}
            <LogoutModal
              title="User Logout"
              body="Do you really want to logout ?"
              submitHandler={signoutHandler}
              successMessage="Logout Successfull!"
              show={showModal}
              onHide={() => setShowModal(false)}
            />
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
